import { Injectable } from '@angular/core';
import { DsChipColorVariant, TableChipConfig } from '@levelaccess/design-system';

import { TranslateService } from '@client/app/translate/translate.service';
import { Api } from '@shared/constants/api';
import { flawStatus } from '@shared/constants/flaw';
import { IAutomatedScanIssue } from '@shared/interfaces/scan-issues.interface';
import { ITask } from '@shared/interfaces/task.interface';

@Injectable({ providedIn: 'root' })
export class FindingTableService {
  constructor(private translateService: TranslateService) {}

  isNewUnviewedIssue(issue: IAutomatedScanIssue): boolean {
    return !issue.isRawFinding && issue.status === flawStatus.open && !issue.viewed;
  }

  getActivityChipConfig(status: flawStatus): TableChipConfig {
    return {
      text:
        status === flawStatus.dismissed
          ? this.translateService.instant('label_dismissed')
          : this.translateService.instant(`label_${status}`) || this.translateService.instant('no_status'),
      colorVariant: this.getActivityChipVariant(status),
    };
  }

  getViewedChipConfig(isNew: boolean): TableChipConfig {
    return {
      text: isNew ? this.translateService.instant('scan_issue_label_new') : this.translateService.instant('viewed'),
      colorVariant: isNew ? DsChipColorVariant.Pink : DsChipColorVariant.Light,
    };
  }

  getTaskUrl(task: Partial<ITask>): string {
    return `/${Api.projects}/${task.projectId}/${Api.tasks}/${task._id}`;
  }

  private getActivityChipVariant(status: flawStatus): DsChipColorVariant {
    switch (status) {
      case flawStatus.closed:
        return DsChipColorVariant.LightGray;
      case flawStatus.dismissed:
        return DsChipColorVariant.Red;
      case flawStatus.open:
      case flawStatus.reOpen:
      default:
        return DsChipColorVariant.Success;
    }
  }
}
